import React, {Component} from "react";
import {Row, Col, Card, CardBody, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import {
    getBookings, resetBookingQuery
} from "../../store/booking/actions";
import {connect} from "react-redux";
import BookingList from "./List/BookingList";
import Paging from "../../components/Pagination/Pagination";
import {Space} from "antd";
import Search from "../../components/Search/Search";
import Refund from "./Refund";
import LoadingCard from "../../components/LoadingCard/LoadingCard";
import ListSearch from "components/ListSearch/ListSearch";
import moment from "moment";
import { formatMoney } from "helpers/currency";
import dayjs from "dayjs";
import { serviceLabel, paymentStatusLabel, tagLabel, roleLabel, bookingStateLabel } from "helpers/adminLabels";

class Bookings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filterModalOpen: false,
            refundModalOpen: false,
            refundBooking: {}
        }
        this.options = [
            {keySearch: 'parentID.name_parentID.surname', titleSearch: 'Име'},
            {keySearch: 'price', titleSearch: 'Цена'},
            // {keySearch: 'professionalID.role', titleSearch: 'Professional role'},
            {keySearch: 'professionalID.name_professionalID.surname', titleSearch: 'Име на специалист'},
            {keySearch: 'time', titleSearch: 'Дата на часа'},

        ]
    }

    componentDidMount() {
        // Reset query and explicitly set bookingsType to 'paid' for main bookings page
        // This ensures we only show paid bookings (SCHEDULED, DONE, CANCELED)
        this.props.resetBookingQuery();
        this.props.getBookings({ bookingsType: 'paid' });
    }

    handleSearch = (q) => {
        this.props.getBookings({ bookingsType: 'paid', q, page: 1 });
    }

    onRefundOpen = (booking) => {
        this.setState({
            refundBooking: booking,
        });
    }
    setFilterModalOpen = (filterModalOpen) => {
        this.setState({filterModalOpen})
    }

    setRefundModalOpen = (refundModalOpen) => {
        this.setState({refundModalOpen})
    }
    refreshPage = () => {
        // Clearing the filter modal shouldn't also drop the free-text search.
        const { q } = this.props.query;
        this.props.resetBookingQuery();
        this.props.getBookings({ bookingsType: 'paid', q: q || '' });
    }

    setPage = (currentPage) => {
        this.props.getBookings({ bookingsType: 'paid', page: currentPage });
    }

    setPageSize = (pageSize) => {
        this.props.getBookings({ bookingsType: 'paid', pageSize, page: 1 });
    }

    onSubmit = (e, search) => {
        e.preventDefault()
        this.setState({ filterModalOpen: false });
        this.props.getBookings({ bookingsType: 'paid', search, page: 1 });
    }

    downloadBookingsToExel = () => {
        const { bookingList } = this.props;
        if (!bookingList || !bookingList.bookings || bookingList.bookings.length === 0) {
            alert("Няма резервации за изтегляне.");
            return;
        }

        const headers = [
            "Стопанин", "Услуга", "Статус", "Статус на плащане", "Статус на часа", "Данни за контрагент", "Възстановяване", "Цена", "Специалист", "Дата на часа", "Създадена на"
        ];

        const rows = bookingList.bookings.map(booking => {
            const parentName = `${booking.parentID?.name || ''} ${booking.parentID?.surname || ''}`;
            const service = serviceLabel(booking.description);
            const status = `${tagLabel(booking.status || '')} / ${tagLabel(booking.meetingType || '')}`;
            const paymentStatus = paymentStatusLabel(booking.paymentStatus);

            const appointmentStatusData = booking?.invoicing?.[0];
            let appointmentStatus = bookingStateLabel(appointmentStatusData?.bookingState) || 'N/A';
            if (appointmentStatusData?.hpnAmount) {
                appointmentStatus += ` | Такса: ${formatMoney(appointmentStatusData.hpnAmount, { locale: "bg" })}`;
            }
            if (appointmentStatusData?.hpnInvoiceNumber > 0) {
                appointmentStatus += ` | Фактура: ${appointmentStatusData.hpnInvoiceNumber} (${dayjs(appointmentStatusData.hpnInvoiceDate).format('DD.MM.YYYY')})`;
            }

            const contragentData = appointmentStatusData?.hpnPaid
                ? `Да (${dayjs(appointmentStatusData.hpnPaidDate).format('DD.MM.YYYY')})`
                : 'N/A';

            const refundAmount = booking.transactions.reduce((partialSum, refund) => partialSum + refund.price, 0).toFixed(2);
            const price = !isNaN(Number(booking.price)) ? Number(booking.price).toFixed(2) : '-';

            const professional = `${roleLabel(booking.professionalID?.role)}: ${booking.professionalID?.name || ''} ${booking.professionalID?.surname || ''}`;

            const appointmentDate = booking?.time ? `${moment(booking.time).format("DD MMM YYYY")} ${moment(booking.time).format("HH:mm")}` : 'N/A';
            const createdAt = booking?.createdAt ? moment(booking.createdAt).format('DD MMM YYYY') : 'N/A';

            return [parentName, service, status, paymentStatus, appointmentStatus, contragentData, refundAmount, price, professional, appointmentDate, createdAt];
        });

        const escapeCsvField = (field) => `"${String(field || '').replace(/"/g, '""')}"`;

        let csvContent = headers.join(",") + "\n" + rows.map(row => row.map(escapeCsvField).join(",")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `bookings_${new Date().toISOString().slice(0, 10)}.csv`;
        link.click();
    }

    render() {
        const { filterModalOpen, refundModalOpen, refundBooking} = this.state
        const {bookingList, loadingBookings, query} = this.props;
        const { page: currentPage, pageSize, search, q } = query;
        
        // Safely extract values with defaults
        const bookings = bookingList?.bookings || [];
        const pages = bookingList?.pages || 1;
        const tags = bookingList?.tags || {};
        
        return (
            <React.Fragment>
                <div className="page-content">
                    <div className="container-fluid">
                        <Breadcrumbs title="Резервации" breadcrumbItem="Резервации"/>

                        <Row>
                            <Col>
                                {!loadingBookings ? <Card>
                                    <div className="list-toolbar py-2">
                                        <Paging setPage={this.setPage} setPageSize={this.setPageSize} pageSize={pageSize} currentPage={currentPage}
                                                pages={pages}/>
                                        <ListSearch
                                            value={q || ""}
                                            onSearch={this.handleSearch}
                                            placeholder="Търсене по стопанин, специалист или любимец"
                                        />
                                        <Space direction="horizontal" className="mr-4">
                                            <Space direction="horizontal" className="mr-4">
                                                <Button type={'button'}
                                                        className='btn btn-info waves-effect waves-light search-btn'
                                                        onClick={this.downloadBookingsToExel}>Изтегли данни</Button>
                                            </Space>
                                            <Button type={'button'}
                                                    className='btn btn-info waves-effect waves-light search-btn'
                                                    onClick={() => this.setFilterModalOpen(!filterModalOpen)}><i
                                                className="bx bx-filter-alt align-middle"></i></Button>
                                            {(search?.text || Object.keys(search?.tagsFilters || {}).length > 0 || search?.searchInArchive) &&
                                                <Button type={'button'}
                                                        className='btn btn-dark waves-effect waves-light search-btn'
                                                        onClick={this.refreshPage}><i
                                                    className='bx bx-revision align-middle'></i></Button>}
                                        </Space>
                                    </div>
                                    <CardBody>
                                        {bookings.length > 0 ? (
                                            <BookingList
                                                list={bookings}
                                                onRemoveItem={this.onRemove}
                                                onEditItem={this.onEdit}
                                                history={this.props.history}
                                                onRefundOpen={this.onRefundOpen}
                                                setRefundModalOpen={this.setRefundModalOpen}
                                                search={search}
                                            />
                                        ) : (
                                            <div className="text-center p-4 text-muted">
                                                Няма намерени резервации
                                            </div>
                                        )}
                                    </CardBody>
                                    <Paging setPage={this.setPage} setPageSize={this.setPageSize} pageSize={pageSize} currentPage={currentPage}
                                            pages={pages}/>
                                </Card> : <LoadingCard />}
                            </Col>
                        </Row>
                    </div>
                </div>
                <Search searchModalOpen={filterModalOpen}
                        options={this.options}
                        filterData={['time']}
                        searchVar={search}
                        tags={tags}
                        onSubmit={this.onSubmit}
                        onCancel={() => this.setFilterModalOpen(false)}/>
                {refundModalOpen && <Refund isNewBookingModalOpen={refundModalOpen}
                                            data={refundBooking?.refund}
                                            onCancel={() => this.setRefundModalOpen(false)}/>}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const {Booking} = state;
    // Ensure query is always an object with a valid search object to prevent runtime errors.
    const query = Booking.query || {
        page: 1, pageSize: 20, search: {text: '', filter: '', tagsFilters: {}, searchInArchive: false}
    };
    
    // The API returns { bookings: [...], total, pages, tags } directly
    // (ApiHelper extracts response.data.data)
    return {...Booking, query};
};

export default connect(mapStateToProps, {
    getBookings,
    resetBookingQuery
})(Bookings);
